<script setup>
import axios from 'axios';
import { ref, onMounted } from "vue";
import InputText from 'primevue/inputtext';
import IconField from 'primevue/iconfield';
import InputIcon from 'primevue/inputicon';
import Button from 'primevue/button';
import DataTable from 'primevue/datatable';
import Column from 'primevue/column';
import Toast from 'primevue/toast';
import Dialog from 'primevue/dialog';
import { FilterMatchMode } from '@primevue/core/api';
import { useToast } from "primevue/usetoast";

const users = ref();
const toast = useToast();
const showPassword = ref(false);
const filters = ref({
  global: { value: null, matchMode: FilterMatchMode.CONTAINS },
});

const selectedUser = ref(null);

const changePasswordDialog = ref(false);
const newPassword = ref('');

const showChangePasswordDialog = (user) => {
  selectedUser.value = user;
  changePasswordDialog.value = true;
  newPassword.value = '';
};

// Función para cambiar la contraseña
async function changePassword() {
    try {
        let response = await axios.post('https://cuadrecaja.pruebasfenix.com/public/api/change-password', 
            { username: selectedUser.value.username, password: newPassword.value }
        );

        if (response.status === 200) {
            toast.add({
                severity: 'success',
                summary: 'Contraseña cambiada',
                detail: 'La contraseña se cambió correctamente.',
                life: 3000
            });
            changePasswordDialog.value = false;
        }
    } catch (error) {
        toast.add({
            severity: 'error',
            summary: 'Contraseña no se pudo cambiar',
            detail: 'Hubo un error al cambiar la contraseña. Por favor, inténtelo de nuevo.',
            life: 3000
        });
    }
};

async function getUsers() {
    try {
        let response = await axios.get('https://cuadrecaja.pruebasfenix.com/public/api/get-users');
        
        users.value = response.data;
    } catch (error) {
        console.log(error);
    }
}

// Cargar usuarios
onMounted(() => {
  getUsers();
});
</script>

<template>
  <div class="py-4 container-fluid">
    <Toast />
    <div class="card z-index-2">
      <div class="row p-4">
        <div class="col-md-3">
          <IconField>
            <InputIcon><i class="pi pi-search" /></InputIcon>
            <InputText 
                class="input" 
                v-model="filters.global.value" 
                type="text"
                autocomplete="off"
                autocorrect="off"
                autocapitalize="off"
                spellcheck="false"
                placeholder="Buscar usuario..." 
            />
          </IconField>    
        </div>
      </div>
      <div class="col-lg-12 mb-lg-0 mb-4">
        <div class="card">
          <div class="mt-3 px-2">
            <DataTable 
              class="m-3" 
              :value="users" 
              :paginator="true" 
              :rows="6"
              :rowsPerPageOptions="[6, 10, 20, 50]" 
              :filters="filters"
              stripedRows 
              resizableColumns 
              columnResizeMode="fit" 
              showGridlines 
              tableStyle="min-width: 50rem"
            >
            <Column field="name" header="Nombre" sortable style="min-width: 15rem"></Column>
              <Column field="username" header="Usuario" sortable style="min-width: 12rem"></Column>
              
              <Column header="Opciones" style="min-width: 10rem">
                <template #body="slotProps">
                  <Button 
                    icon="pi pi-key" 
                    outlined 
                    rounded 
                    severity="help" 
                    @click="showChangePasswordDialog(slotProps.data)"
                    label="Cambiar contraseña"
                  />
                </template>
              </Column>
            </DataTable>
          </div>
        </div>
      </div>
    </div>

    <!-- Diálogo para cambiar contraseña -->
    <Dialog 
      v-model:visible="changePasswordDialog" 
      modal 
      header="Cambiar contraseña" 
      :style="{ width: '25rem' }"
    >
      <div class="flex align-items-center gap-3 mb-3">
        <div class="flex flex-column" style="width: 100%">
            <label for="newPassword">Nueva contraseña para: {{ selectedUser?.name }}</label>
            <InputText 
            id="newPassword" 
            v-model="newPassword" 
            :type="showPassword ? 'text' : 'password'"
            autocomplete="new-password"
            autocorrect="off"
            autocapitalize="off"
            spellcheck="false"
            placeholder="Ingrese nueva contraseña"
            />
            <InputIcon @click="showPassword = !showPassword" class="input-icon">
                <i :class="showPassword ? 'pi pi-eye-slash' : 'pi pi-eye'" />
            </InputIcon>
        </div>
      </div>
      <div class="buttons">
        <Button 
          type="button" 
          label="Cancelar" 
          severity="secondary" 
          @click="changePasswordDialog = false"
        ></Button>
        <Button 
          type="button" 
          label="Cambiar" 
          @click="changePassword"
          :disabled="!newPassword"
        ></Button>
      </div>
    </Dialog>
  </div>
</template>

<style scoped>
.input {
    height: 3rem !important;
    width: 100%;
}

.button-margin {
    margin-right: 8px;
}

.buttons {
    display: flex;
    flex-direction: row;
    gap: 20px;
    justify-content: flex-end;
}

.input-icon {
    cursor: pointer;
    margin-left: 10px;
    position: relative;
}
</style>